import TagManager from 'react-gtm-module';
import { compose, defaultTo, fromPairs, map, path, pick, pipe, zip, curry, values } from 'ramda';
import { TICKET_TYPES } from '../../modules/booking/booking.constants';

const mapTicketTypesToEventKeys = curry((keysArray, ticketsTypesArray, data) =>
  pipe(
    zip,
    map(([key, ticketKey]) => [
      key,
      compose(
        defaultTo(0),
        path(['types', ticketKey, 'ticketNumber'])
      )(data),
    ]),
    fromPairs
  )(keysArray, ticketsTypesArray)
);

const KEYS = {
  bookingAdults: 'bookingAdults',
  bookingChildren: 'bookingChildren',
  bookingInfants: 'bookingInfants',
};

const EVENTS = {
  routeChange: 'virtualPageView',
  bookingPurchaseComplete: 'bookingPurchaseComplete',
};

const EVENT_PROPERTIES = {
  [EVENTS.bookingPurchaseComplete]: [
    KEYS.bookingAdults,
    KEYS.bookingChildren,
    KEYS.bookingInfants,
    'bookingDate',
    'bookingTimes',
    'bookingCurrency',
    'bookingMarket',
    'bookingValue',
  ],
};

export const init = () =>
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
    preview: process.env.REACT_APP_GTM_PREVIEW,
    auth: process.env.REACT_APP_GTM_AUTH,
  });

export const logEvent = (event, properties) => TagManager.dataLayer({ dataLayer: { event, ...properties } });

export const push = (dataLayer = {}) => TagManager.dataLayer({ dataLayer });

export const logRouteChange = virtualPagePath => logEvent(EVENTS.routeChange, { virtualPagePath });

export const getTicketsTypesForGTM = mapTicketTypesToEventKeys(
  [KEYS.bookingAdults, KEYS.bookingChildren, KEYS.bookingInfants],
  [TICKET_TYPES.Adult, TICKET_TYPES.Child, TICKET_TYPES.Infant]
);

export const logBookingPurchaseComplete = pipe(
  ({ tickets, ...other }) => ({
    ...getTicketsTypesForGTM(tickets),
    bookingDate: tickets.date,
    bookingTimes: values(tickets.timeSlots),
    ...other,
  }),
  pick(EVENT_PROPERTIES[EVENTS.bookingPurchaseComplete]),
  properties => logEvent(EVENTS.bookingPurchaseComplete, properties)
);
